import React, { useState, useEffect } from "react";
import "./news.css";
import CardFilter from "../card/CardFilter";
import NewsPostItem from "./NewsPostItem";
import api from "../../api/config";

const News = () => {
  const [news, setNews] = useState([]);
  const [filter, setFilter] = useState("Today");
  const handleFilterChange = (filter) => {
    setFilter(filter);
  };

  // const fetchData = async () => {
  //   await fetch("http://localhost:4500/news")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setNews(data);
  //     })
  //     .catch((e) => console.log(e.message));
  // };

  const fetchData = async () => {
    try {
      const response = await api.get("/news", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      setNews(response.data.data);
    } catch (err) {
      console.error(`Error:${err.message}`);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="card">
      <CardFilter filterChange={handleFilterChange} />
      <div className="card-body pb-0">
        <h5 className="card-title">
          News &amp; <span>| {filter}</span>
        </h5>
      </div>
      <div className="news">
        {news &&
          news.length > 0 &&
          news.map((item) => <NewsPostItem key={item.id} item={item} />)}
      </div>
    </div>
  );
};

export default News;
